import { Theme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import HelpInfoWrapper from '../help-info-wrapper';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: theme.customComponents.table.footer.height,
    display: 'flex'
  }
}));

interface Props {
  label: string;
  value: string;
  tooltip: string;
}

const FooterInfo = ({ label, value, tooltip }: Props) => {
  const classes = useStyles();

  return (
    <Box data-testid="table-footer-info" className={classes.container}>
      <HelpInfoWrapper tooltip={tooltip} tooltipPlacement="top">
        <Box mr={1}>
          <Typography variant="h3">{label}:</Typography>
        </Box>
        <Typography variant="h4">{value}</Typography>
      </HelpInfoWrapper>
    </Box>
  );
};

export default FooterInfo;
